import { render } from "./batch-row-membership.vue?vue&type=template&id=38d7106e&lang=pug"
import script from "./batch-row-membership.vue?vue&type=script&lang=js"
export * from "./batch-row-membership.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__